/* eslint-disable max-len */
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { SelectedCardDetails, SharedService } from '../../core/services/shared.service';
import _ from 'lodash';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { TemplateService } from '../../core/services/template.service';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import { I } from '@angular/cdk/keycodes';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'card-details-selector',
  templateUrl: './card-details-selector.component.html',
  styleUrls: ['./card-details-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardDetailsSelectorComponent implements OnInit {

  @Input() module: string;
  @Input() options: any;
  @Input() sectionType: string;
  @Input() dispatchTab: string;
  @Input() triggerChangeDetection : boolean; //Psuedo input to trigger change detection

  // eslint-disable-next-line @typescript-eslint/naming-convention
  MAX_ROW = 5;  MAX_COLUMN = 2;
  selectedPosition: any;
  customSelectedAttributes: any = [];
  attributeList: any;
  routeAttributeList: any;
  cardPreviewHTML: string = '';
  optionsAvailable: any[] = [];
  optionsBucket: any[] = [];
  maxSingleLinePickerColumn = 3; //Routes grid card selector's max column
  badgeLabels = ['Skillsets'];
  routeGridPreviewTemplate: string = '';
  singletonRows = ['work_order_scheduled_date@Scheduled-Date-&-Time', 'employee_name@Technician-Name', 'route_name@Route-Name'];
  // eslint-disable-next-line max-len, @typescript-eslint/naming-convention
  previewRouteDetails = {'route_uid':'12345','route_name':'Weekend - North route','total_jobs':2,'duration':1,'departure':'2024-04-06T23:33:00.000Z','route_end_time':'2024-04-07T00:33:00.000Z','route_type':'FASTEST','transport_mode':'CAR','start_location':{'street':'Brooklyn Methodist Hospital, 6th Street, Brooklyn, NY, USA','geo_cords':[40.6684619,-73.9798295]},'end_location':{'name':'Prospect Park ','street':'Brooklyn, NY 11215, USA','geo_cords':[12.9815179,80.2179755]},'is_recurrence':false,'is_locked':false,'is_deleted':false,'assigned_to':[{'user':{'first_name':'Trevor','last_name':'Alan','profile_picture':'https://s3.ap-south-1.amazonaws.com/staging.in.pro.zuper/attachments/6c287db0-ff7c-11e7-b3a8-29b417a4f3fa/da506460-6a12-11ec-bb9b-5794434a5493.jpg'}},{'user':{'first_name':'Cristiano','last_name':'','profile_picture':'https://s3.ap-south-1.amazonaws.com/staging.in.pro.zuper/attachments/6c287db0-ff7c-11e7-b3a8-29b417a4f3fa/6024fd20-080c-11ed-be73-8b6ed5c86b4b.jpg'}},{'user':{'first_name':'Albert','last_name':'Rio'}}],'created_at':'2024-04-05T09:33:41.676Z','total_distance':18052,'total_time':2645};
  moduleFormMap = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'GRID': this._sharedService.gridForm, 'SCHEDULER': this._sharedService.schedulerForm, 'EMPLOYEE': this._sharedService.employeeForm, 'MAP': this._sharedService.mapForm
  };
  moduleAttributeMap = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'GRID': this._sharedService.jobAttributes, 'SCHEDULER': this._sharedService.jobAttributes,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'EMPLOYEE': this._sharedService.employeeAttributes, 'MAP': null, 'ROUTE': this._sharedService.routeCardAttributes
  };
  activeTippyInstance: any;
  tippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    placement: 'right',
    interactive: true,
    appendTo: document.body,
    hideOnClick: true,
    onShow: (instance: any): any => {
      this.activeTippyInstance = instance;
    }
  };
  cardViewType = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    JOB: 'card_view', ROUTE: 'route_card_view', SCHDULER: 'card_view'
  };
  objectKeys = Object.keys;

  constructor(
    private _localisationService: LocalisationService,
    public _sharedService: SharedService,
    public tippyService: NgxTippyService,
    private _utilityService: UtilityService,
    private templateService: TemplateService,
    private dispatchBoardService: DispatchBoardService
    ) { }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    this.attributeList = this.sectionType === 'ROUTE' ? this.moduleAttributeMap[this.sectionType] : this.moduleAttributeMap[this.module];
    this.optionsAvailable = this.attributeList;
    this.setSelectionLimiters();
    this.initiateSelectedCardDetails(this.module);
    this.initiateAvailableOptions();
    this.updateCustomPreview();
  }

  initiateAvailableOptions(): void {
    Object.keys(this.customSelectedAttributes).forEach((row) => {
      this.customSelectedAttributes[row].forEach((option) => {
        this.deleteAvailableOptions(option);
      });
    });
  }

  updateCustomPreview(): void {
    if (this.module === 'GRID' && this.sectionType === 'ROUTE') {
      const routeSelectors = this.getRouteCardSelectors();
      this.routeGridPreviewTemplate =  this.templateService.getRouteCardRenderer(this.previewRouteDetails, routeSelectors);
    }
  }

  getRouteCardSelectors(): any[] {
    const routeGridAttributes = this.customSelectedAttributes || {};
    const routeCardValues = this.removeRouteCardDefaultAttributes(routeGridAttributes);
    const selectors = [];
    Object.values(routeCardValues).forEach((columns: any) => {
      columns.forEach((column: any) => {
        selectors.push(column?.selector);
      });
    });
    return selectors;
  }

  removeRouteCardDefaultAttributes(routeGridCard: any): any {
    const defaultRouteGridCardSelectors = ['route_name', 'duration', 'total_jobs'];
    const updatedRouteGridcard = {};
    let rowIndex: number = 0;
    const routeCardRows: any = Object.keys(routeGridCard);
    routeCardRows.forEach((row: any) => {
       const rowContent = routeGridCard[row].filter((column: any) => !defaultRouteGridCardSelectors.includes(column?.selector));
      if (rowContent?.length) {
        updatedRouteGridcard[rowIndex] = rowContent;
        rowIndex ++;
      }
    });
    return updatedRouteGridcard;
  }

  setSelectionLimiters(): void {
    if (!this._utilityService.isEmptyOrUndefined(this.options)) {
      this.MAX_COLUMN = this.options?.MAX_COLUMN;
      this.MAX_ROW = this.options?.MAX_ROW;
    }
  }

  initiateSelectedCardDetails(module: string): void {
    const lastSelectedDetails = this.moduleFormMap[module].get(this.cardViewType[this.sectionType]).value || [];
    let filteredList = {};
    let newRowIndex = 1;
    Object.keys(lastSelectedDetails).map(key => Number(key)).forEach((rowNumber) => {
      filteredList[newRowIndex] = [];
      lastSelectedDetails[rowNumber].forEach((attribute: any, columnIndex: number) => {
        if (_.some(this.attributeList, { key: attribute.key })) {
          attribute.column = columnIndex + 1;
          attribute.row = newRowIndex;
          attribute = this.dispatchBoardService.setDisplayKeyAndValue(attribute, this.attributeList);
          filteredList[newRowIndex].push(attribute);
        }
      });
      if (filteredList[newRowIndex].length === 0) {
        delete filteredList[newRowIndex];
      }
      else {
        newRowIndex ++;
      }
    });
    if (this.module === 'GRID' && this.sectionType === 'ROUTE') {
      filteredList =  this.convertSelectedAttributesToCustomColumns(filteredList);
    }
    this.customSelectedAttributes = filteredList;
  }

  groupByKey(data: any, key: any): any {
    return data.reduce((ele: any, x: any) => {
      (ele[x[key]] = ele[x[key]] || []).push(x);
      return ele;
    }, {});
  };

  sortByKey(array: any, key: any): any {
    return array.sort((a: any, b: any)=> {
      const x = a[key]; const y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  counter(i: number): any[] {
    return Array(i).fill(1).map((x, value) => value + 1);
  }

  onTippyOpen(event: any): void {
    this.selectedPosition = event.srcElement.data;
    this._sharedService.tippyName = event.srcElement.data.tippyName;
  }

  updateSelectedAttribute(option: any, action: string): void {
    const row = option.row;
    switch (action) {
      case 'Add': {
        if (this.customSelectedAttributes.hasOwnProperty(row)) {
          this.customSelectedAttributes[row].push(option);
        }
        else {
          this.customSelectedAttributes[row] = [{ ...option }];
        }
        break;
      }
      case 'Delete': {
        _.remove(this.customSelectedAttributes[row], { key: option.key, label: option.label });
        this.sanitizeSelectedAttribute(option);
        break;
      }
    }
    //Route card customaization to custom columns
    if (this.module === 'GRID' && this.sectionType === 'ROUTE') {
      this.customSelectedAttributes = this.convertSelectedAttributesToCustomColumns(this.customSelectedAttributes);
      this.updateCustomPreview();
    }
    this._sharedService.updateFormFields(this.moduleFormMap[this.module], this.cardViewType[this.sectionType], this.customSelectedAttributes);
  }


  sanitizeSelectedAttribute(deletedValue: any): void {
    if (this.customSelectedAttributes[deletedValue.row].length === 0) {
      delete this.customSelectedAttributes[deletedValue.row];
      const selectedAttributes = {};
      let rowCount = 1;
      Object.keys(this.customSelectedAttributes).map(key => Number(key)).forEach((rowNumber) => {
        selectedAttributes[rowCount] = this.customSelectedAttributes[rowNumber].map((ele: any) => ({ ...ele, row: rowCount }));
        rowCount++;
      });
      this.customSelectedAttributes = selectedAttributes;
    }
  }

  onAttributeSelected(selectedValue: any): void {
    delete this.selectedPosition['tippyName'];
    const selectedOption = { ...selectedValue, ...this.selectedPosition };
    this.deleteAvailableOptions(selectedValue);
    this.updateSelectedAttribute(selectedOption, 'Add');
    if (this.activeTippyInstance) {
      this.activeTippyInstance.hide();
    }
  }

  onAttributeDeleted(deletedValue: SelectedCardDetails): void {
    if (deletedValue.dismissable) {
      this.updateSelectedAttribute(deletedValue, 'Delete');
      this.addAvailableOption(deletedValue);
    }
  }

  getAvailableOptions(): any {
    return this.optionsAvailable;
  }

  updateAvailableOptions(options: any): void {
    this.optionsAvailable = options;
  }

  addAvailableOption(option: any): void {
    this.removeFromOptionsBucket(option);
    const availableOptions = [...this.optionsAvailable];
    availableOptions.push(option);
    this.updateAvailableOptions(availableOptions);

  }

  deleteAvailableOptions(deletedOption: any): void {
    let availableOptions = [...this.optionsAvailable];
    availableOptions = availableOptions.filter(option => option.key !== deletedOption.key).map((attribute: any) => this.dispatchBoardService.setDisplayKeyAndValue(attribute, this.attributeList));
    this.updateAvailableOptions(availableOptions);
    this.addToOptionsBucket(deletedOption);
  }

  addToOptionsBucket(data: any): void {
    this.optionsBucket.push(data);
  }

  removeFromOptionsBucket(deletedOption: any): void {
    this.optionsBucket = this.optionsBucket.filter(option => option.key !== deletedOption.key);
  }

  cardRowTrackBy(index: number, item: any): any {
    return item?.key;
  }

  //Instead of default column count, create custom object with n columns
  convertSelectedAttributesToCustomColumns(selectionObject: any, newColumnCount: number = this.MAX_COLUMN): any {
    const allAttributes = Object.values(selectionObject).flat();
    const updatedSelectionObject = {};
    let totalAttributes = allAttributes.length - 1;
    let row = 1; let column = 1; let iterIndex = 0;
    while (totalAttributes >= 0) {
      let attribute: any = allAttributes[iterIndex];
      if (this.singletonRows.includes(attribute?.key)) {
        row = Object.keys(updatedSelectionObject).length + 1;
        column = 1;
        attribute.row = row;
        attribute.column = column;
        attribute = this.dispatchBoardService.setDisplayKeyAndValue(attribute, this.attributeList);
        updatedSelectionObject[row] = [attribute];
        totalAttributes --;
        iterIndex ++;
        row ++;
        continue;
      }
      if (column > newColumnCount) {
        column = 1;
        row ++;
      }
      attribute.row = row;
      attribute.column = column;
      attribute = this.dispatchBoardService.setDisplayKeyAndValue(attribute, this.attributeList);
      if(updatedSelectionObject.hasOwnProperty(row)) {
        updatedSelectionObject[row].push(attribute);
      }
      else {
        updatedSelectionObject[row] = [attribute];
      }
      totalAttributes --;
      iterIndex ++;
      column ++;
    }
    return updatedSelectionObject;
  }
}
